<template>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 row-gap-4 col-gap-6">
        <simple-service-status-card sub-title="Service" :name="service.name" :status="service.status" :interruptionId="service.interruptionId" :serviceId="service.id" :key="service.id" v-for="service in services">
        </simple-service-status-card>
    </div>
</template>

<script>
    export default {
        props: {
            services: {
                required: true,
                type: Array,
            },
        },
    }
</script>
